<template>
  <div class="uk-container uk-background-default">
    <div>
      {{errorText}}
    </div>
    <div v-if="mainLoading">
      <div uk-spinner="ratio: 3"></div>
    </div>
    <div v-else>
      <div v-if="!hasPodOperator" class="uk-alert-warning" uk-alert>
        <p>
          This page is available only for POD Tracking operators. Please contact
          support to enable access for your account.
        </p>
      </div>
      <div v-else>
        <br />

        <!-- <div v-if="user.onboardedPayments && user.onboardedTerminalLogins"> -->
        <div>
          <!-- <div
            v-for="(load, loadIndex) in loads"
            :key="load.loadId"
          >
            <LoadModal
              v-bind:modalId="'active-load-model-' + loadIndex"
              :load="load"
              @updateLoad="updateUser"
            ></LoadModal>
          </div> -->

              <!-- @createdCustomer="refreshUserData" -->
          <div uk-flex>

            <button class="uk-button uk-button-large uk-button-primary uk-form-controls" v-on:click="isShowAddNewLoad=!isShowAddNewLoad">
              <div v-if="isShowAddNewLoad"><span uk-icon="icon: minus"></span>Close</div>
              <div v-else><span uk-icon="icon: plus"></span>New Load</div>
            </button>

            <transition name="slide">

              <div class="uk-background-sections rel" v-if="isShowAddNewLoad">
                <!-- <button class="close&#45;btn" v&#45;on:click="isShowAddNewLoad=false" uk&#45;close></button> -->
                <button class="uk-close-large close-btn" v-on:click="isShowAddNewLoad=false" uk-close></button>
                <h4 class="mt-0">Add new load</h4>
                <EnterLoad
                  @addedLoad="refreshUserData"
                  @createdDriver="refreshUserData"
                  @openCreateDriver="openCreateDriverModal"
                  @openCreateCustomer="openCreateCustomerModal"
                  :drivers="drivers"
                  :customers="customers"
                  ></EnterLoad>
              </div>
            </transition>

            <h2>My Loads</h2>

            <div uk-switcher="animation: uk-animation-fade; toggle: > *">
              <button class="uk-button uk-button-default" type="button">
                Active
                <span class="uk-badge">{{activeLoads.length}}</span>
              </button>

              <!-- <button class="uk-button uk-button-default" type="button">
                Active
                <span
                  class="uk-badge"
                  v-bind:class="{'uk-label-success':containersAvailable.length > 0}"
                >{{containersAvailable.length}}</span>
              </button> -->
              <button class="uk-button uk-button-default" type="button">
                Archived
                <span
                  class="uk-badge"
                  v-bind:class="{'uk-label-black':archivedLoads.length > 0}"
                >{{archivedLoads.length}}</span>
              </button>
            </div>

            <ul class="uk-switcher uk-margin">
              <li>
                <LoadsTable

                  @refreshLoads="refreshUserData"
                  @archiveLoad="archiveLoad"
                  :loads="activeLoads"
                  :user="user"
                  tableType="active"

                  :condensed="user.enableCustomerInfo != true"
                ></LoadsTable>
              </li>
              <!-- <li>
                <LoadsTable

                  @refreshLoads="refreshUserData"

                  @archiveLoad="archiveLoad"
                  :loads="loadsOnboard"
                  :user="user"
                  :condensed="user.enableCustomerInfo != true"
                ></LoadsTable>
              </li> -->
              <li>
                <LoadsTable

                  @refreshLoads="refreshUserData"
                  @unarchiveLoad="unarchiveLoad"
                  :loads="archivedLoads"
                  :user="user"
                  tableType='archived'

                  :condensed="user.enableCustomerInfo != true"
                ></LoadsTable>
              </li>
            </ul>

          </div>
          <div>
            <button
              class="uk-button uk-button-default"
              v-on:click="refreshUserData"
            ><span uk-icon="refresh"></span> Refresh All Load Data</button>
          </div>

          <hr class="uk-divider-icon">

          <h2>My Drivers</h2>
          <button
            class="uk-button uk-button-primary"
            type="button"
            v-on:click="showCreateDriverModal"

          ><div uk-icon="icon: plus"></div> Add new driver</button>

          <DriversTable
            :drivers="drivers"
          ></DriversTable>

          <h2>My Customers</h2>
          <button
            class="uk-button uk-button-primary"
            type="button"
            v-on:click="showCreateCustomerModal"
          ><div uk-icon="icon: plus"></div> Add new customer</button>

          <Customers
            :module="'POD'"
            ref="customersComp"
            @createdCustomer="updateCustomersChild"
          >
          </Customers>

          <CreateDriverModal
            :open="isCreateDriverOpen"
            @close="isCreateDriverOpen = false"
            @createdDriver="refreshUserData"
          />

          <CreateCustomerModal
            v-model:isOpen="isCreateCustomerOpen"
            @createdCustomer="refreshUserData"
          />

        </div>

        <br />
      </div>
    </div>

  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

import LoadsTable from './LoadsTable.vue';
import DriversTable from '../Driver/DriversTable.vue';
import EnterLoad from './EnterLoad.vue';
import Customers from '../Customer/Customers.vue';

import CreateDriverModal from '../Driver/CreateDriverModal.vue'; 
import CreateCustomerModal from '../Customer/CreateCustomerModal.vue';

import USER_ALL_DATA from '../../gql/pod_tracking/UserAllData.gql';
// import UPDATE_LOAD from '../../gql/pod_tracking/UpdateLoad.gql';

// declare let Cohere: any;

// UIkit removed from modal system; using Tailwind/Vue-only modals

type LoadWrapper = {
  isArchived: boolean;
  load: any;
};

type DriverWrapper = {
  driverName: string;
  driver: any;
};

type Customer = {
  name: string;
};

type User = {
  loads: LoadWrapper[];
  drivers: DriverWrapper[];
  customers: Customer[];
  enableCustomerInfo?: boolean;
  fullName?: string;
  email?: string;
};

const createEmptyUser = (): User => ({
  loads: [],
  drivers: [],
  customers: [],
});

export default defineComponent({
  name: 'LoadsView',
  
  components: {
    EnterLoad,
    LoadsTable,
    DriversTable,
    Customers,
    CreateDriverModal,
    CreateCustomerModal,
    // LoadModal,
    // ContainerTable,
    // Payments,
    // Profile,
  },
  data() {
    return {
      user: createEmptyUser(),
      loads: [],
      selectedLoad: -1,
      loading: [],
      mainLoading: true,
      finishedLoads: [] as any[],
      // errorText: 'default',
      errorText: null,
      isShowAddNewLoad: false,
      hasPodOperator: false,
      isCreateDriverOpen: false,
      isCreateCustomerOpen: false,
    };
  },
  computed: {
    isOnboardedPayments() {
      return (this as any).user.onboardedPayments;
    },
    activeLoads() {
      const userLoads = ((this as any).user?.loads) ?? [];
      const ret = userLoads
        .filter((load) => !load.isArchived)
        .map((load) => load.load);
      console.log('active loads: ', ret);
      return ret;
      // return enumerateLoads((this as any).loads);
    },
    archivedLoads() {
      const userLoads = ((this as any).user?.loads) ?? [];
      const ret = userLoads
        .filter((load) => load.isArchived)
        .map((load) => load.load);
      console.log('archived loads: ', ret);
      return ret;
    },
    drivers() {
      const driversFormatted = (((this as any).user?.drivers) ?? [])
        .map((d) => {
          const ret = { ...d.driver }
          ret.name = d.driverName;
          return ret;
        });

      return driversFormatted.sort((a, b) =>
        a.name.localeCompare(b.name),
      );
    },
    customers() {
      const customersFormatted = ((this as any).user?.customers) ?? [];

      return customersFormatted.sort((a, b) =>
        a.name.localeCompare(b.name),
      );
    },
    // activeLoads() {
    //   const containersWithIdx = enumerateLoads(this.user.activeLoads);

    //   return (containersWithIdx as Array<any>).filter((container) =>
    //     (this as any).containerAvailable(container.container),
    //   );
    // },
  },
  methods: {
    openCreateDriverModal() {
      (this as any).isCreateDriverOpen = true;
    },
    openCreateCustomerModal() {
      (this as any).isCreateCustomerOpen = true;
    },
    isLoadActive(load) {
      return load.is_completed === false;
    },
    updateUser() {
      const vm = (this as any);

      vm.$apollo.queries.operator.refetch();
    },
    // refreshLoadsStatus(loadIndex: any) {
    // },
    updateCustomersChild() {
      const vm = (this as any);

      vm.refreshUserData();
      (vm.$refs.customersComp as any).updateCustomer();
    },
    refreshUserData() {
      const vm = (this as any);

      console.log('Refresh all user data called');
      vm.$apollo.queries.user.refetch();
    },
    archiveLoad(loadId: number) {
      const vm = (this as any);

      console.log('got event');
      // const load: any = this.activeLoads[loadIndex];

      // console.log(load);
      vm.$apollo.queries.user.refetch();
      // this.$apollo.queries.archivedLoads.refetch();
      window.alert(`Archived Load ${loadId}`);
    },
    unarchiveLoad(loadId: number) {
      const vm = (this as any);
      // const load: any = this.activeLoads[loadIndex];

      // console.log(load);
      vm.$apollo.queries.user.refetch();
      // this.$apollo.queries.archivedLoads.refetch();
      window.alert(`Un-archived Load ${loadId}`);
    },
    showCreateDriverModal() {
      (this as any).openCreateDriverModal();
    },
    showCreateCustomerModal() {
      (this as any).openCreateCustomerModal();
    },

  },
  props: {
    msg: String,
  },
  apollo: {
    // customers: {
    //   query: AllCustomers,
    // },
    // loads: {
    //   query: ALL_LOADS,
    //   result(result) {
    //     console.log('all_laods: ', result);
    //   },
    //   error(error) {
    //     console.error('all_loads ERROR: ', error);
    //   },
    // },
    user: {
      query: USER_ALL_DATA,
      result(result) {
        const vm = (this as any);
        const currentUser = result?.data?.user ?? null;
        vm.hasPodOperator = Boolean(currentUser);
        vm.user = currentUser ?? createEmptyUser();
        // const user = result.data.user;
        // Cohere.identify(
        //   user.id, // Required: can be any unique ID
        //   {
        //     // displayName: user.fullName, // Optional // TODO: Enable this when all users have names set
        //     displayName: user.email, // Optional
        //     email: user.email, // Optional
        //   },
        // );

        console.log('[fetching all user data] result: ', result);
        console.log('(this as any).errorText: ', vm.errorText);
        vm.mainLoading = false;
        // console.log('all_loads: ', result.data.user.loads);
      },
      error(error) {
        const vm = (this as any);

        vm.mainLoading = false;
        vm.hasPodOperator = false;
        vm.user = createEmptyUser();
        console.error('Fetching user data failed: ', error);
        // this.error = 'Getting user data from server failed - are you connected to the internet?';
        vm.errorText = 'new error';
        // this.errorText = JSON.stringify(error.message);
        console.log('err: ', vm.errorText);
      },
    },
    // archivedContainers: {
    //   query: ArchivedContainersQuery,
    // },
  },
});
</script>

<style lang="scss">

.uk-icon[uk-icon="icon: file-pdf"] svg {
  color: red;
}

.uk-background-sections {
  background-color: #b1d5e5;
}

.close-btn {
  position: absolute;
  top: 5px;
  right: 10px;

}

.mt-0 {
  margin-top: 0px;
}

.rel {
  position: relative;
}

.add-new-load-btn-slide-enter-active, .slide-enter-active {
   -moz-transition-duration: 0.1s;
   -webkit-transition-duration: 0.1s;
   -o-transition-duration: 0.1s;
   transition-duration: 0.1s;
   -moz-transition-timing-function: ease-in;
   -webkit-transition-timing-function: ease-in;
   -o-transition-timing-function: ease-in;
   transition-timing-function: ease-in;
}

/* .add-new-load-btn-slide-leave-active, .slide-leave-active { */
.slide-leave-active {
   -moz-transition-duration: 0.2s;
   -webkit-transition-duration: 0.2s;
   -o-transition-duration: 0.2s;
   transition-duration: 0.2s;
   -moz-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
   -webkit-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
   -o-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
   transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
}

.add-new-load-btn-slide-enter-to, .add-new-load-btn-slide-leave, .slide-enter-to, .slide-leave {
   max-height: 100px;
   overflow: hidden;
}

/*.add-new-load-btn-slide-enter, .add-new-load-btn-slide-leave-to, .slide-enter, .slide-leave-to {*/
.add-new-load-btn-slide-enter, .slide-enter, .slide-leave-to {
   overflow: hidden;
   max-height: 0;
}

</style>
